import { isValidElement } from 'react';

var hasChildren = function hasChildren(element) {
  return isValidElement(element) && Boolean(element.props.children);
};

export default hasChildren;